import { render, staticRenderFns } from "./Trace.vue?vue&type=template&id=0baa0f32&"
import script from "./Trace.vue?vue&type=script&lang=ts&"
export * from "./Trace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports